// extracted by mini-css-extract-plugin
module.exports = {"separator":"_745b262"};